import Box from "@material-ui/core/Box";
import { useTheme, Theme } from "@material-ui/core/styles";
import React from "react";
import useEnv from "../../hooks/env";
import BetaStageIcon from "./BetaStageIcon";
import StagingStageIcon from "./StagingStageIcon";
import TestStageIcon from "./TestStageIcon";

function getStageIndicatorIcon(stage: string) {
  switch (stage) {
    case "beta":
      return <BetaStageIcon />;
    case "staging":
      return <StagingStageIcon />;
    case "test":
      return <TestStageIcon />;
    default:
    // do nothing
  }
}

function StageIndicator() {
  const { environment } = useEnv();
  const { spacing } = useTheme<Theme>();
  const indicator = getStageIndicatorIcon(environment);

  if (indicator) {
    return (
      <Box position="fixed" top={spacing(2)} right={spacing(2)} style={{ zIndex: 999999 }}>
        {indicator}
      </Box>
    );
  }

  return null;
}

export default StageIndicator;
